import { render, staticRenderFns } from "./DataSourcePlugin.vue?vue&type=template&id=6225aafd&scoped=true&"
import script from "./DataSourcePlugin.vue?vue&type=script&lang=js&"
export * from "./DataSourcePlugin.vue?vue&type=script&lang=js&"
import style0 from "./DataSourcePlugin.vue?vue&type=style&index=0&id=6225aafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6225aafd",
  null
  
)

export default component.exports